export default {
  getCapMega: state => state.mega,
  getCapLarge: state => state.large,
  getCapMedium: state => state.medium,
  getCapMedian: state => state.mediam,
  getCapSmall: state => state.small,
  getCapMicro: state => state.micro,
  getCapAsOfDate: state => state.asOfDate
};
